import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import Loader from '../ui/loader/Loader';

import { useUser } from '@/hooks/useUser';
import { useUserStore } from '@/hooks/useUserStore';
import { IReactChildrenProps } from '@/interfaces/IReactChildren';
import { AuthRoutes } from '@/interfaces/auth/AuthRoutes.enum';
import { AppRoutes } from '@/interfaces/routes/AppRoutes';
import { ConsumerRoutes } from '@/interfaces/routes/ConsumerRoutes';
import { notificationService } from '@/services/notification.service';

const UserGuard = ({ children }: IReactChildrenProps) => {
	const { user, isLoading } = useUser();
	const { store, isLoading: isLoadingStore } = useUserStore();

	useEffect(() => {
		if (!isLoading && (!user || user.roles.length === 0)) {
			notificationService.error(
				'You do not have permission to access this page',
			);
		}
	}, [user, isLoading, isLoadingStore, store]);

	if (isLoading) {
		return (
			<Loader className="flex items-center justify-center h-full w-full" />
		);
	}

	if (!user || user.roles.length === 0) {
		return <Navigate to={AuthRoutes.SignOut} />;
	}

	if (user && user.roles.includes('consumer')) {
		return <Navigate to={ConsumerRoutes.LiveHaggles} />;
	}

	if (!store && user && !user.roles.includes('admin') && !user.inventoryType) {
		return <Navigate to={AppRoutes.ManageStore} />;
	}

	return <>{children}</>;
};

export default UserGuard;
